// Function index:
//   computeViewKeys(q, r)                       — axial-distance disc of
//                                                  size VIEW_RADIUS around
//                                                  the player; matches the
//                                                  server's viewRingCoords.
//   visibilityFor(viewKeys, key, discovered)    — visible / foggy / unknown
//                                                  for one hex.
//   touchedFogKeys(prev, next)                  — symmetric difference of
//                                                  two view rings — the set
//                                                  of hexes whose visibility
//                                                  flipped after a move.
//
// Phase 2.5 fog of war helpers — pure functions so the mount can call
// them without a closure factory. Recomputed on every self-move.

import { VIEW_RADIUS, type Visibility } from './palette.js';

export function computeViewKeys(currentQ: number, currentR: number): Set<string> {
  const keys = new Set<string>();
  for (let dq = -VIEW_RADIUS; dq <= VIEW_RADIUS; dq++) {
    const rMin = Math.max(-VIEW_RADIUS, -dq - VIEW_RADIUS);
    const rMax = Math.min(VIEW_RADIUS, -dq + VIEW_RADIUS);
    for (let dr = rMin; dr <= rMax; dr++) {
      keys.add(`${currentQ + dq},${currentR + dr}`);
    }
  }
  return keys;
}

export function visibilityFor(viewKeys: Set<string>, key: string, discovered: boolean): Visibility {
  if (viewKeys.has(key) && discovered) return 'visible';
  if (discovered) return 'foggy';
  return 'unknown';
}

export function touchedFogKeys(prev: Set<string>, next: Set<string>): Set<string> {
  const touched = new Set<string>();
  for (const k of prev) touched.add(k);
  for (const k of next) touched.add(k);
  return touched;
}
